import React, { useEffect, useState } from "react";
import { Button, Col, Card, Pagination, Row } from "react-bootstrap";
import BTable from "react-bootstrap/Table";
import { useGlobalFilter, usePagination, useSortBy, useTable, } from "react-table";

import { Accessors, Common, GlobalFilter } from "../../../../helper";
import { PupilAction, studentColumns } from "./";
import { LoadingSpinner } from "../../../Shared";
import { isEmptyArray, isEmptyObject } from "../../../../util";
import * as commonApi from "../../../../api/commonApi";
import { styles, tableSizeP } from "../../"

import "../../../../assets/stlyes/SchoolAdminTableStyle.scss";


const Table = (props) => {
  const { columns, data, changeTabs } = props;
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, globalFilter, setGlobalFilter, page, canPreviousPage, canNextPage, pageOptions, pageCount, gotoPage, nextPage, previousPage, setPageSize, state: { pageIndex, pageSize }, } = useTable({ columns, data, initialState: { pageIndex: 0, pageSize: 10 }, }, useGlobalFilter, useSortBy, usePagination);

  return (
    <>
      <Row className="mb-3">
        <Col className="d-flex justify-content-start">
          <GlobalFilter
            filter={globalFilter}
            setFilter={setGlobalFilter}
            searchBy={"Search by Name/UPN"}
          />
        </Col>
        <Col className="d-flex justify-content-end">
          <Button type="submit" variant="success" onClick={() => { changeTabs() }}>
            Go Back to classes
          </Button>
        </Col>
      </Row>
      <BTable striped bordered hover responsive {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup, i) => (
            <tr key={i} {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column, i) => (
                <th key={i}
                  {...column.getHeaderProps(
                  )}
                >
                  {column.render("Header")}
                </th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr key={i} {...row.getRowProps()}>
                {row.cells.map((cell, i) => {
                  return (
                    <td key={i} {...cell.getCellProps()}>
                      {cell.render("Cell")}
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </BTable>

      <div
        className="d-flex justify-content-end"
        style={styles.paginate}
      >
        <span className="d-flex align-items-baseline">
          {Common.RowsPerPage}
          <select
            className="form-control w-auto mx-2"
            value={pageSize}
            onChange={(e) => {
              setPageSize(Number(e.target.value));
            }}
          >
            {[5, 10, 20, 30, 40, 50].map((pageSize) => (
              <option key={pageSize} value={pageSize}>
                {pageSize}
              </option>
            ))}
          </select>
        </span>
        <span
          className="d-flex align-items-center"
          style={{ marginBottom: "13px" }}
        >
          {Common.Page}{" "}
          <strong>
            {" "}
            {pageIndex + 1} of {pageOptions.length}{" "}
          </strong>{" "}
        </span>

        <Pagination className="justify-content-end">
          <Pagination.First onClick={() => gotoPage(0)} disabled={!canPreviousPage} />
          <Pagination.Prev onClick={() => previousPage()} disabled={!canPreviousPage} />
          <Pagination.Next onClick={() => nextPage()} disabled={!canNextPage} />
          <Pagination.Last onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage} />
        </Pagination>
      </div>
    </>
  );
}

const PuiplTable = (props) => {
  const { pupilClassID, changeTabs, setFullScreen } = props
  const [puiplData, setPuiplData] = useState();
  const columns = React.useMemo(() => studentColumns, []);
  const [isLoading, setIsLoading] = useState(false);

  const getData = async () => {
    setIsLoading(true);
    const viewStudents = await commonApi.viewStudents({
      id: pupilClassID
    });
    if (!isEmptyArray(viewStudents.Items)) {

      const updatedAdminPupilItems = viewStudents.Items.map((item) => {
        let ppDisplayed = false;

        item[Accessors.Action] = (<PupilAction pupilId={item.id} pupilClassID={pupilClassID} getData={getData} />);
        item[Accessors.Year] = (<div style={{ width: "100px" }}>{`${Common.Year} ${item[Accessors.Year]}`}</div>);

        item[Accessors.OtherNeeds] = (
          <div className="d-flex" style={{ gap: "10px" }}>
            {item[Accessors.OtherNeeds].childLookedAfter && !ppDisplayed && (
              <span style={styles.characterisctics}>
                <div className="greenPointer_" style={{ backgroundColor: "var(--greater-colour)" }}></div>{Common.PP}{(ppDisplayed = true)}
              </span>
            )}
            {item[Accessors.OtherNeeds].freeSchoolMealsE6 && !ppDisplayed && (
              <span style={styles.characterisctics}>
                <div className="greenPointer_" style={{ backgroundColor: "var(--greater-colour)" }}></div>{Common.PP}{(ppDisplayed = true)}
              </span>
            )}
            {item[Accessors.OtherNeeds].freeSchoolMeals && !ppDisplayed && (
              <span style={styles.characterisctics}>
                <div className="greenPointer_" style={{ backgroundColor: "var(--greater-colour)" }}></div>{Common.PP}{(ppDisplayed = true)}
              </span>
            )}
            {item[Accessors.OtherNeeds].eal && (
              <span style={styles.characterisctics} >
                <div className="greenPointer_" style={{ backgroundColor: "var(--expected-colour)" }}></div> {Common.Eal}
              </span>
            )}
            {item[Accessors.OtherNeeds].serviceChild && (
              <span style={styles.characterisctics}>
                <div className="greenPointer_" style={{ backgroundColor: "var(--below-colour)" }}></div>{Common.SC}
              </span>
            )}
          </div>
        );
        return item;
      });
      setPuiplData(updatedAdminPupilItems)

    } else {
      setPuiplData();
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <React.Fragment>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <>
          {!isEmptyObject(puiplData && puiplData) ? (
            < Row style={{ paddingRight: setFullScreen() }}>
              <Col sm={tableSizeP} style={styles.tableStyle}>
                <Card>
                  <Card.Body>
                    {puiplData && (
                      <Table columns={columns} data={puiplData && puiplData} changeTabs={changeTabs} />
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          ) : (
            <>
              <Row>
                <Col className="d-flex">
                  <Button
                    type="submit"
                    variant="success"
                    onClick={() => {
                      changeTabs()
                    }}
                  >
                    {Common.GoToClass}
                  </Button>
                </Col>
              </Row>
              <div className="d-flex justify-content-center">
                <h1>{Common.NoPupilFound}</h1>
              </div>
            </>
          )}
        </>
      )
      }
    </React.Fragment >
  );
};

export { PuiplTable }
